module.exports = __webpack_public_path__ + "img/gcash.4cdbc3fc.jpg";